/* Scoped adapters. No Jackery cart, tracking, account or review scripts. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.hp3pmAdapterReady) return;
    root.dataset.hp3pmAdapterReady = 'true';
    const official = root.querySelector('[data-hp3pm-official]');
    if (!official) return;
    official.querySelectorAll('.blocks-tabs-blocks').forEach((block, group) => {
      const list = block.querySelector('.tabs-nav-ul');
      const items = [...block.querySelectorAll('.blocks-tab-item')];
      if (!list || !items.length) return;
      list.replaceChildren();
      const buttons = items.map((item, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.role = 'tab';
        button.textContent = item.querySelector('.tab-nav')?.textContent.trim() || `View ${index + 1}`;
        const panel = item.querySelector('[role=tabpanel]') || item;
        panel.id = `${root.id}-tab-${group}-${index}`;
        button.setAttribute('aria-controls', panel.id);
        const li = document.createElement('li');li.append(button);list.append(li);
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', event => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length;
          activate(next);buttons[next].focus();
        });
        return button;
      });
      function activate(index) {
        items.forEach((item, i) => {item.hidden = i !== index;item.classList.remove('invisible');if(i!==index)item.querySelectorAll('video').forEach(v=>v.pause());});
        buttons.forEach((button, i) => {button.setAttribute('aria-selected', String(i === index));button.tabIndex = i === index ? 0 : -1;});
      }
      activate(0);
    });
    const runtime = official.querySelector('[data-hp3pm-runtime]');
    if(runtime){
      const units=runtime.querySelector('[data-runtime-units]'),packs=runtime.querySelector('[data-runtime-packs]'),voltage=runtime.querySelector('[data-runtime-voltage]'),watts=runtime.querySelector('input'),output=runtime.querySelector('output'),summary=runtime.querySelector('[data-runtime-summary]');
      const calculate=()=>{const n=Number(units.value),count=Number(packs.value),v=Number(voltage.value),load=Number(watts.value),limit=(v===240?4000:2000)*n,capacity=3584*n*(count+1);watts.max=String(limit);output.textContent=load>0&&load<=limit?`${(capacity*.85/load).toFixed(1)} hours`:`Enter 1–${limit.toLocaleString('en-US')}W`;summary.textContent=`${capacity.toLocaleString('en-US')}Wh selected capacity · ${limit.toLocaleString('en-US')}W continuous limit at ${v}V. Battery packs are counted per main unit.`;};
      runtime.addEventListener('input',calculate);runtime.addEventListener('change',calculate);calculate();
    }
    const equipment = {
  "21-0001-000430": [
    "HomePower 3600 Pro Max × 1",
    "AC Charging Cable × 1"
  ],
  "60-363600-US00473": [
    "HomePower 3600 Pro Max × 1",
    "Battery Pack HomePower 3600 × 1",
    "AC Charging Cable × 1"
  ],
  "60-360000-US00475": [
    "HomePower 3600 Pro Max × 1",
    "Manual Transfer Switch × 1",
    "40A Charging Cable × 1",
    "AC Charging Cable × 1"
  ],
  "60-360050-US00472": [
    "HomePower 3600 Pro Max × 1",
    "SolarSaga 500 X × 1",
    "AC Charging Cable × 1"
  ],
  "60-360050-US00476": [
    "HomePower 3600 Pro Max × 1",
    "SolarSaga 500 X × 1",
    "Manual Transfer Switch × 1",
    "40A Charging Cable × 1",
    "AC Charging Cable × 1"
  ],
  "60-363650-US00477": [
    "HomePower 3600 Pro Max × 1",
    "Battery Pack HomePower 3600 × 1",
    "SolarSaga 500 X × 1",
    "Manual Transfer Switch × 1",
    "40A Charging Cable × 1",
    "AC Charging Cable × 1"
  ],
  "60-360000-US00478": [
    "HomePower 3600 Pro Max × 2",
    "40A Charging Cable × 1",
    "Parallel Communication Cable",
    "AC Charging Cable × 1",
    "Manual Transfer Switch × 1"
  ]
};
    function box(key, title) {
      const list = official.querySelector('[data-hp3pm-box-items]');
      if (!list) return;
      official.querySelector('[data-hp3pm-box-name]').textContent = title || 'HomePower 3600 Pro Max';
      list.replaceChildren(...(equipment[key] || ["Confirm included equipment with LIVVOLT for this configuration."]).map(text => {const li = document.createElement('li');li.textContent = text;return li;}));
    }
    root.addEventListener('hp3pm:variant', e => box(e.detail.box, e.detail.title));
    const selected = root.querySelector('[data-hp3pm-variant].is-selected');
    box(selected?.dataset.box || 'basic', selected?.textContent.trim());
    official.querySelectorAll('[data-hp3pm-youtube]').forEach(button => button.addEventListener('click', () => {
      const frame = document.createElement('iframe');
      frame.className = 'hp3pm-video-frame';frame.title = 'Official Jackery how-to video';
      frame.src = `https://www.youtube-nocookie.com/embed/${button.dataset.hp3pmYoutube}?autoplay=1`;
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen = true;
      const player = document.createElement('div');player.className = 'hp3pm-youtube-player';player.append(frame);
      const link = document.createElement('a');link.className = 'hp3pm-youtube-link';link.href = `https://www.youtube.com/watch?v=${button.dataset.hp3pmYoutube}`;link.target = '_blank';link.rel = 'noopener';link.textContent = 'Video not playing? Watch on YouTube ↗';
      button.replaceWith(player);player.after(link);
    }));
    official.querySelectorAll('jds-button[label="Watch Video"]').forEach(custom => {
      const source=custom.dataset.videoSrc;
      const poster=custom.dataset.videoPoster;
      if(!source){custom.remove();return;}
      const button=document.createElement('button');button.type='button';button.className='hp3pm-watch-video';button.textContent='▶ Watch Video';custom.replaceWith(button);
      button.addEventListener('click',()=>{
        const dialog=document.createElement('dialog');dialog.className='hp3pm-video-dialog';const close=document.createElement('button');close.type='button';close.textContent='Close ×';
        const video=document.createElement('video');video.src=source;video.controls=true;video.playsInline=true;video.poster=poster||'';
        const player=document.createElement('div');player.className='hp3pm-modal-player';const cover=document.createElement('img');cover.src=poster||'';cover.alt='Official HomePower 3600 Pro Max product video cover';
        const play=document.createElement('button');play.type='button';play.textContent='▶ Play video';const status=document.createElement('p');status.className='hp3pm-video-status';status.role='status';
        const start=()=>{status.textContent='';video.play().catch(()=>{status.textContent='Select Play video to start. If unavailable, please try again later.';});};
        play.addEventListener('click',start);video.addEventListener('playing',()=>{player.classList.add('is-playing');status.textContent='';});video.addEventListener('error',()=>{player.classList.remove('is-playing');status.textContent='Video unavailable. The cover remains visible; select Play video to retry.';});
        close.addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{video.pause();dialog.remove();});player.append(cover,video,play);dialog.append(close,player,status);document.body.append(dialog);dialog.showModal();start();
      });
    });
    official.querySelectorAll('[data-hp3pm-open-devices]').forEach(button=>button.addEventListener('click',()=>{
      const dialog=document.getElementById(button.dataset.hp3pmOpenDevices);if(dialog){dialog.showModal();dialog.querySelector('[data-hp3pm-close]')?.focus();}
    }));
    official.querySelectorAll('[data-hp3pm-close]').forEach(button=>button.addEventListener('click',()=>button.closest('dialog').close()));
    official.querySelectorAll('[class^="ai-image-slider-track-"]').forEach(track=>{
      const component=track.closest('[class^="ai-image-slider-container-"]');let index=0;
      const slides=[...track.children];
      const go=step=>{index=(index+step+slides.length)%slides.length;track.scrollTo({left:track.clientWidth*index,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
      const previous=component.querySelector('[class*="ai-image-slider-prev-"]'),next=component.querySelector('[class*="ai-image-slider-next-"]');
      if(previous){previous.type='button';previous.setAttribute('aria-label','Previous battery feature');previous.addEventListener('click',()=>go(-1));}
      if(next){next.type='button';next.setAttribute('aria-label','Next battery feature');next.addEventListener('click',()=>go(1));}
      track.tabIndex=0;track.setAttribute('aria-label','Battery features. Scroll horizontally to view more.');track.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();go(e.key==='ArrowRight'?1:-1);}});
    });
    official.querySelectorAll('.accordion-title,.accordion-header').forEach(button => {
      const content = button.nextElementSibling;
      if (!content) return;
      button.setAttribute('role', 'button');button.tabIndex = 0;button.setAttribute('aria-expanded', 'true');
      content.style.display = 'block';content.style.height = 'auto';content.style.maxHeight = 'none';
      const toggle = () => {content.hidden = !content.hidden;button.setAttribute('aria-expanded', String(!content.hidden));};
      button.addEventListener('click', toggle);
      button.addEventListener('keydown', e => {if (['Enter', ' '].includes(e.key)) {e.preventDefault();toggle();}});
    });
    function youtubeDialog(id){
      const dialog=document.createElement('dialog');dialog.className='hp3pm-video-dialog';const close=document.createElement('button');close.type='button';close.textContent='Close ×';const frame=document.createElement('iframe');frame.title='Official Jackery HomePower 3600 Pro Max video';frame.src=`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;
      const link=document.createElement('a');link.href=`https://www.youtube.com/watch?v=${id}`;link.textContent='Video not playing? Watch on YouTube ↗';link.target='_blank';link.rel='noopener';link.className='hp3pm-external-video';
      close.addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>dialog.remove());dialog.append(close,frame,link);document.body.append(dialog);dialog.showModal();close.focus();
    }
    official.querySelectorAll('[data-hp3pm-watch-youtube]').forEach(b=>b.addEventListener('click',()=>youtubeDialog(b.dataset.hp3pmWatchYoutube)));
    official.querySelectorAll('[data-hp3pm-youtube]').forEach(b=>b.addEventListener('click',()=>youtubeDialog(b.dataset.hp3pmYoutube)));
    official.querySelectorAll('[data-hp3pm-native]').forEach(player=>{
      const video=player.querySelector('video'),play=player.querySelector('[data-hp3pm-native-play]'),status=player.querySelector('[data-hp3pm-native-status]');let visible=false;
      video.muted=true;video.playsInline=true;
      const start=()=>{status.textContent='';video.play().catch(()=>{player.classList.remove('is-playing');status.textContent='Select Play video to start. If unavailable, please try again.';});};
      play.addEventListener('click',start);video.addEventListener('playing',()=>{player.classList.add('is-playing');status.textContent='';});video.addEventListener('error',()=>{player.classList.remove('is-playing');status.textContent='Video unavailable. The cover remains visible; select Play video to retry.';});
      new IntersectionObserver(entries=>{visible=entries[0].isIntersecting&&player.getClientRects().length>0;if(visible&&player.dataset.auto==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches)start();else if(!visible)video.pause();},{threshold:.15}).observe(player);
    });
    official.querySelectorAll('[data-hp3pm-scene-tab]').forEach(b=>b.addEventListener('click',()=>{
      const scene=b.closest('.hp3pm-scene');scene.querySelectorAll('[data-hp3pm-scene-panel]').forEach(p=>p.hidden=p.dataset.hp3pmScenePanel!==b.dataset.hp3pmSceneTab);scene.querySelectorAll('[data-hp3pm-scene-tab]').forEach(t=>t.setAttribute('aria-pressed',String(t===b)));
    }));
    // Independent covers remain visible until a selected video is genuinely playing.
    // No dependency on global hidden/lg:block utilities or the source site's scroll runtime.
    official.querySelectorAll('[data-hp3pm-routing]').forEach(scene => {
      const panels = [...scene.querySelectorAll('[data-hp3pm-stage]')];
      const buttons = [...scene.querySelectorAll('[data-hp3pm-route-tab]')];
      const caption = scene.querySelector('[data-hp3pm-stage-caption]');
      const status = scene.querySelector('[data-hp3pm-route-status]');
      const mobile = matchMedia('(max-width:1023.98px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0, inView = false;
      function play(panel, requested = false) {
        const video = panel.querySelector('video');
        if (!video || panel.hidden || (!requested && (reduced.matches || video.dataset.failed))) return;
        const source = mobile.matches ? video.dataset.srcMobile : video.dataset.srcPc;
        const image = panel.querySelector('picture img');
        video.poster = image.currentSrc || image.src;
        if (video.getAttribute('src') !== source) {video.src = source;video.preload = 'metadata';video.load();}
        if (requested) {delete video.dataset.failed;status.textContent = '';}
        video.play().catch(error => {
          panel.classList.remove('is-playing');
          if (!panel.hidden && error.name !== 'AbortError') status.textContent = error.name === 'NotAllowedError' ? 'Select Play video to start.' : 'Video unavailable. The product image remains visible; you can try Play video again.';
        });
      }
      panels.forEach((panel, index) => {
        const video = panel.querySelector('video');if (!video) return;
        video.addEventListener('playing', () => {if (!panel.hidden) {panel.classList.add('is-playing');status.textContent = '';}});
        video.addEventListener('pause', () => panel.classList.remove('is-playing'));
        video.addEventListener('error', () => {video.dataset.failed = 'true';panel.classList.remove('is-playing');if (!panel.hidden) status.textContent = 'Video unavailable. The product image remains visible; you can try Play video again.';});
        panel.querySelector('[data-hp3pm-route-play]').addEventListener('click', () => play(panel, true));
        panel.id = `${root.id}-routing-${index}`;
      });
      function activate(index, requested = false) {
        active = index;status.textContent = '';caption.textContent = panels[index].dataset.caption;
        panels.forEach((panel, i) => {panel.hidden = i !== index;if (i !== index) {panel.querySelector('video')?.pause();panel.classList.remove('is-playing');}});
        buttons.forEach((button, i) => {button.setAttribute('aria-selected', String(i === index));button.tabIndex = i === index ? 0 : -1;});
        if (inView || requested) play(panels[index], requested);
      }
      buttons.forEach((button, index) => {
        if (!panels[index].id) panels[index].id = `${root.id}-routing-${index}`;
        button.setAttribute('aria-controls', panels[index].id);panels[index].setAttribute('role', 'tabpanel');
        button.addEventListener('click', () => activate(index, true));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          activate(next, true);buttons[next].focus();
        });
      });
      new IntersectionObserver(entries => {inView = entries[0].isIntersecting;if (inView) play(panels[active]);else panels.forEach(panel => panel.querySelector('video')?.pause());}, {rootMargin:'0px'}).observe(scene);
      mobile.addEventListener('change', () => {if (inView) play(panels[active]);});
      activate(0);
    });
    root.querySelectorAll('[data-hp3pm-mode]').forEach(button => button.addEventListener('click', () => {
      const model = button.dataset.hp3pmMode === 'model';
      if (model && location.protocol === 'file:') {
        let note = root.querySelector('[data-hp3pm-model-note]');
        if (!note) {note = document.createElement('p');note.dataset.hp3pmModelNote = '';note.role = 'status';root.querySelector('.hp3pm-gallery__modes').after(note);}
        note.textContent = '3D requires an HTTP preview or the Shopify product page. Photos are available in this local file preview.';
        return;
      }
      root.querySelector('[data-hp3pm-model]').hidden = !model;
      root.querySelector('[data-hp3pm-zoom]').hidden = model;
      root.querySelectorAll('[data-hp3pm-mode]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      if (model && !customElements.get('model-viewer') && !document.querySelector('[data-hp3pm-model-library]')) {
        const script = document.createElement('script');script.src = button.dataset.modelScript;script.dataset.hp3pmModelLibrary = 'true';document.head.append(script);
      }
    }));
  }
  const boot = scope => scope.querySelectorAll('[data-hp3pm-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
